import ConsultingCaseListModelBase from '../_generated/modelBases/consulting-case-list-model-base';

export default class ConsultingCaseListModel extends ConsultingCaseListModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
